import './band.scss';
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import FacebookIcon from './../../assets/images/facebook-logo.png'
import InstaIcon from './../../assets/images/instagram-logo.png'
import SpotifyIcon from './../../assets/images/spotify.png'
import YoutubeIcon from './../../assets/images/youtube-logo.png'
import ReactMarkdown from 'react-markdown'

export default function Band({bandData, path}) {
  const location = useLocation();
  const currentRAW = bandData.find(x => path + x.attributes.rigUrl === location.pathname);
  const current = currentRAW.attributes;
  const image = current?.image?.data?.attributes?.formats?.medium?.url ?? current?.image?.data?.attributes?.url
  return (
    <div className='bandBox'>
      <div className='content'>
        <h1 className='title'>{current.name}</h1>
        <div className='info'>
          <span className='genre'>{current.genre}</span> | <span className='home'>{current.ort}</span>
        </div>
        <div className='box'>
		  { image &&
			<div className='bandPic'>
				{<img src={image} alt={current.name+ '- Bandimage'}/>}
			</div>
		  }
          { current.spotify && <Spotify url={current.spotify} /> }
          <div className='text'>
            <div><ReactMarkdown>{current.text}</ReactMarkdown></div>
            <div className='links'>
              {current.facebookUrl && <a target="_blank" href={current.facebookUrl} title={'zum Facebook-Account von' + current.name} rel="noreferrer"><img className="icon" src={FacebookIcon} alt="Rock im Garten Facebook Logo" /></a>}
              {current.instaUrl && <a target="_blank" href={current.instaUrl} title={'zum Instagram-Account von' + current.name} rel="noreferrer"><img className="icon" src={InstaIcon} alt="Rock im Garten Instagram Logo" /></a>}
              {current.youtube && <a target="_blank" href={current.youtube} title={'zum Youtube-Account von' + current.name} rel="noreferrer"><img className="icon" src={YoutubeIcon} alt="Rock im Garten Youtube Logo" /></a>}
              {current.spotify && <a target="_blank" href={current.spotify} title={'zum Spotify-Account von' + current.name} rel="noreferrer"><img className="icon" src={SpotifyIcon} alt="Rock im Garten Spotify Logo" /></a>}
            </div>
            {current.url && <><br/><a href={current.url} title={'Link zu ' + current.name} className='link' target="_blank" rel="noreferrer"> -{'>'} zur Homepage von {current.name}</a></>}
          </div>
        </div>
      </div>
    </div>
  );
}


/**
 * @param {{url: string}} props
 */
function Spotify(props) {
    const embedUrl = useMemo(() => {
        try {
          const url = new URL(props.url)

          if (url.pathname.startsWith("/artist")) {
              const id = url.pathname.split("/")[2]
              return `https://open.spotify.com/embed/artist/${id}?utm_source=generator&theme=0`
          }

          if (url.pathname.startsWith("/intl-de/artist")) {
              const id = url.pathname.split("/")[3]
              return `https://open.spotify.com/embed/artist/${id}?utm_source=generator&theme=0`
          }
        } catch (e) {
          return null
        }
    }, [props.url])

    if (!embedUrl) {
        return null
    }

    return <SocialMediaIframe src={embedUrl} title='spotify' className='spotify' />
}

/**
 * @param {{ src: string; title: string; className: string }} props
 */
function SocialMediaIframe(props) {
    return (
        <iframe
            title={props.title}
            src={props.src}
            className={props.className}
            style={{ borderRadius: "12px" }}
            width="100%"
            height="100%"
            frameBorder={0}
            allow="encrypted-media"
            loading="lazy"
        />
    )
}

